module.exports = __webpack_public_path__ + "img/gry_4.1020b5bd.png";